import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_jkhzdth9kx: FaireBrandEntity = {
  token: "b_jkhzdth9kx",
  type: "brand",
  name: "Wholesalesir",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a8c47de0be3b19682c063375d7e819349f6097e97f7b43ff993b01560aabdb7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e3dd8b1c9b595d075714779f1c8866b76e60d6d464bdcc1627fcb9f146722cd8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a8c47de0be3b19682c063375d7e819349f6097e97f7b43ff993b01560aabdb7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e3dd8b1c9b595d075714779f1c8866b76e60d6d464bdcc1627fcb9f146722cd8.jpeg",
  location: "Walunt, CA, USA",
  minimumOrderDollars: 135,
  rating: 4.3,
  reviewCount: 652,
  isInsider: true,
  description:
    "We are wholesale the great women clothing to all the world,hope we can do long time business with faire",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:43.142Z",
    importedBy: "entity-db-cli",
  },
};
